module.exports = __webpack_public_path__ + "static/media/turn-blue.bd22f4bd.jpg";